import {Config} from '../config/env/companies'

// @ts-ignore
const casted = window.__BD_CONFIG
// eslint-disable-next-line
export const config : Config =  casted
